export default __webpack_public_path__ + "static/media/npc-masterImage.80b75098.png";